/**
 * module name - tradeHistory
 * 法币购买nft首页基本数据
 */

export default {
  namespaced: true,
  state: {
    //交易历史详情
    details: {},
  },
  mutations: {
    set_details(state, newData) {
      state.details = newData;
    },
  },
};
